// The backend's reasons for refusing an added stop (GTFSTripStopService.ValidateAsync), in Albanian.
// The form cannot prevent the first two, so those are the ones users actually hit; a reason not
// listed here falls back to the page's generic message.
const REASONS: [RegExp, string][] = [
  [/already has an added stop/i, "Udhëtimi e ka tashmë një ndalesë në këtë stacion"],
  [/already the trip's departure or arrival/i, "Stacioni është nisja ose mbërritja e udhëtimit"],
  [/overlaps the trip's added stop/i, "Ndalesa mbivendoset në kohë me një ndalesë tjetër të këtij udhëtimi"],
  [/must come after the trip's departure/i, "Ndalesa duhet të jetë pas nisjes së udhëtimit"],
  [/cannot leave before it arrives/i, "Ndalesa nuk mund të niset para se të mbërrijë"],
  [/^Trip \d+ does not exist/i, "Orari nuk ekziston"],
  [
    /no GTFS stop and no coordinates/i,
    "Stacioni nuk ka stacion GTFS as koordinata, feed-i nuk mund ta vendosë"
  ],
  [/source note is longer/i, "Shënimi i burimit është më i gjatë se 200 karaktere"],
  [/Added stop not found/i, "Ndalesa nuk u gjet"]
];

export const tripStopErrorText = (message: string | undefined, fallback: string): string => {
  const hit = REASONS.find(([pattern]) => pattern.test(message ?? ""));
  return hit ? hit[1] : fallback;
};
